
const $ = jQuery.noConflict();

// Toogle class in Body when click on Burger menu
const body = document.querySelector('body');
const burgerBtn = document.querySelector('.burger-btn');
const blackBackground = document.querySelector('.black-background');
if (burgerBtn) {
    burgerBtn.addEventListener('click', function () {
        body.classList.toggle('mobile-menu-active');
        blackBackground.classList.toggle('black-background-is-active');
    });
}


// Toggle Black Background when Menu is active
// if ($(window).width() > 1399) {
//   $('.main-menu > ul > .menu-item-has-children').hover(function () {
//     console.log('Clicked!!');
//     $('.black-background').toggleClass('black-background-is-active');
//   });
// }


//Add class to Mobile menu Items
if ($(window).width() <= 1399) {

    const mobileMenuItems = document.querySelectorAll("li.menu-item-has-children");
    for (const item of mobileMenuItems) {
        item.addEventListener('click', function (event) {
            item.classList.toggle("menu-item-open");
        })
    }
    ;

    $('li.menu-item-has-children').click(
        function () {
            $(this).toggleClass('mobile-list-items-clicked')
        },
    );

}


// Jump to next Section
$(".next-section").click(function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: '+=700'
    }, 500);
});


//Add attributes for Video
$(document).ready(function () {
    $('.background-video .wp-video-shortcode').attr('autoplay', true);
    $('.background-video .wp-video-shortcode').attr('loop', true);
});

// OneSignal Initialization
// console.log("OneSignal Initialization");
// window.addEventListener('load', function () {
// 	window._oneSignalInitOptions.promptOptions = {
// 		slidedown: {
// 			prompts: [{
// 				type: "push",
// 				autoPrompt: true,
// 				text: {
// 					/* actionMessage limited to 90 characters */
// 					actionMessage: "ALLES NEU! Lass dich über Neuigkeiten informieren.",
// 					/* acceptButton limited to 15 characters */
// 					acceptButton: "Gerne",
// 					/* cancelButton limited to 15 characters */
// 					cancelButton: "Nein",
// 				},
// 			}]
// 		}
// 	}
// 	window.OneSignal = window.OneSignal || [];
// 	window.OneSignal.push(function () {
// 		window.OneSignal.init(window._oneSignalInitOptions);
// 	});
// 	window.OneSignal.showSlidedownPrompt();
// });

// video block
$(document).on('click', '.video__poster, .video__title', function () {
    $('.video__pop-up').removeClass('show');
    $('.video').removeClass('show');
    $(this).parent().addClass('show');
    $index = $('.video_list .video').index($('.video_list .video.show'));
    $(`.video__pop-up.video-${$index + 1}`).addClass('show');
    $('#overlay').addClass('show');
});
$('#overlay').on('click', function () {
    $('.video__pop-up').removeClass('show');
    $('.video__pop-up').trigger('pause');
    $('#overlay').removeClass('show');
});

// scroll-to-top button
const backToTopButton = document.querySelector(".back-to-top")

if (backToTopButton) {
    const scrollContainer = () => {
        return document.documentElement || document.body;
    };

    document.addEventListener("scroll", () => {
        if (scrollContainer().scrollTop > 500) {
            backToTopButton.classList.remove("hidden")
        } else {
            backToTopButton.classList.add("hidden")
        }
    })

    const goToTop = () => {
        document.body.scrollIntoView({
            behavior: "smooth",
        });
    };

    backToTopButton.addEventListener("click", goToTop);
}

// no arrows in sigli image product
if ($('.swiper-product-image .swiper-slide').length <= 1) {
    $('.custom-button-prev').addClass('d-none');
    $('.custom-button-next').addClass('d-none');
}


/**
 * Flipdown.js - countdown timer
 */
const countdown = document.querySelector('#flipdown');
if (countdown) {
    const seconds = +countdown.getAttribute('data-time');

    if (seconds > 0) {
        // Unix timestamp (in seconds) to count down to
        const timeLeft = (new Date().getTime() / 1000) + seconds;

        // Set up FlipDown
        const flipdown = new FlipDown(timeLeft).start().ifEnded(() => {
            console.log('The countdown has ended!');
        });
    }
}

jQuery(document).ready(function ($) {
    features_landing_swiper();
    product_accessories__slider();
    c_product__slider();
    // ajax_single_product(); 
    price_wrapper();
});

function features_landing_swiper() {
    let mobile = window.matchMedia('(min-width: 0px) and (max-width: 1023px)');
    let desktop = window.matchMedia('(min-width: 1024px)');
    let swiper = null;
    let init = false;

    function enableSwiper() {
        if (!init) {
            init = true;
            swiper = new Swiper('.features_landing_swiper', {
                slidesPerView: 'auto',
                autoplay: false,
                loop: false,
                spaceBetween: 20,
                direction: 'horizontal',
            });
        }
    }

    function disableSwiper() {
        if (init) {
            swiper.destroy();
            swiper = null;
            init = false;
        }
    }

// Initial check on page load
    if (mobile.matches) {
        enableSwiper();
    } else {
        disableSwiper();
    }

// Update Swiper on window resize
    $(window).on('resize', function () {
        if (mobile.matches) {
            enableSwiper();
        } else {
            disableSwiper();
        }
    });

}

function product_accessories__slider() {
    let mobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)');
    let desktop = window.matchMedia('(min-width: 1025px)');
    let swiper = null;
    let init = false;

    function enableSwiper() {
        if (!init) {
            init = true;
            swiper = new Swiper('.product_accessories__slider', {
                slidesPerView: 'auto',
                autoplay: false,
                loop: false,
                spaceBetween: 0,
                direction: 'horizontal',
            });
        }
    }

    function disableSwiper() {
        if (init) {
            swiper.destroy();
            swiper = null;
            init = false;
        }
    }

// Initial check on page load
    if (mobile.matches) {
        enableSwiper();
    } else {
        disableSwiper();
    }

// Update Swiper on window resize
    $(window).on('resize', function () {
        if (mobile.matches) {
            enableSwiper();
        } else {
            disableSwiper();
        }
    });

}

function c_product__slider() {


    swiper = new Swiper('.c-product__slider', {
        slidesPerView: 1,
        autoplay: false,
        loop: false,
        spaceBetween: 0,
        direction: 'horizontal',
        navigation: {
            nextEl: '.c-product__slider .swiper-button-next',
            prevEl: '.c-product__slider .swiper-button-prev',
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            dynamicBullets: true,
        },
    });


}

//AJAX Add to Cart handling on single product page
function ajax_single_product(){
    $('.single_add_to_cart_button').on('click', function(e){
        e.preventDefault();
        $thisbutton = $(this),
            $form = $thisbutton.closest('form.cart'),
            id = $thisbutton.val(),
            product_qty = $form.find('input[name=quantity]').val() || 1,
            product_id = $form.find('input[name=product_id]').val() || id,
            variation_id = $form.find('input[name=variation_id]').val() || 0;
        var data = {
            action: 'ql_woocommerce_ajax_add_to_cart',
            product_id: product_id,
            product_sku: '',
            quantity: product_qty,
            variation_id: variation_id,
        };
        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function (response) {
                $thisbutton.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $thisbutton.addClass('added').removeClass('loading');
            },
            success: function (response) {
                if (response.error & response.product_url) {
                    window.location = response.product_url;
                    return;
                } else {
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                    $('.woocommerce-notices-wrapper').html(`<div class="woocommerce-message">${response.message}</div>`);
                }
                if ($('.mini-cart').hasClass('mini-cart--empty')) {
                    $('.mini-cart').removeClass('mini-cart--empty').append("<span class='mini-cart__total'>"+response.count+"</span>");
                } else {
                    if ($('.mini-cart__total').length) {
                        $('.mini-cart__total').text(response.count);
                    } else {
                        $('.mini-cart').removeClass('mini-cart--empty').append("<span class='mini-cart__total'>" + response.count + "</span>");
                    }
                }
            },
        });
    });
}

function price_wrapper(){
    if ($('.bundle_wrap').length) {
        var bundleWrap = $(".bundle_wrap");
        var bundlePrice = bundleWrap.find(".bundle_price");
        var legalPriceInfo = bundleWrap.find(".legal-price-info");

        var newDiv = $("<div>").addClass("d-inline-block position-relative");

        bundlePrice.add(legalPriceInfo).wrapAll(newDiv);
    }

    if ($('.woocommerce-page .product .product-main .summary .default-price>.price del').length) {
        $('.woocommerce-page .product .product-main .summary .default-price').addClass('pb-1');
    }

}

